var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Option_1;
import React, { Component, Fragment } from 'react';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { DataContext, RouteContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, bool, element, eventListener, expression, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, ClickEvent, CloseEvent, FocusEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { HistoryService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isFunction, seizeAndForwardChildrenEvents, trigger } from '@philips-internal/oswald-ui-utils';
import { CollapseArrowDirection } from '../collapse-arrow/collapse-arrow-constants.js';
import { CollapseArrow } from '../collapse-arrow/collapse-arrow.js';
import { Popover } from '../popover/popover.js';
import OptionAPI from './option-api.js';
import './option.css';
const OptionContainer = {
    acceptedTypes: [
        ComponentType.NAVIGATION,
    ],
    name: '',
};
let Option = Option_1 = class Option extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onClick = (event, routeContext) => {
            const { route, onClick, preventDefault = Option_1.defaultProps.preventDefault, stopPropagation = Option_1.defaultProps.stopPropagation, } = this.props;
            if (preventDefault) {
                event.preventDefault();
            }
            if (stopPropagation) {
                event.stopPropagation();
            }
            if (route) {
                const completeRoute = routeContext.nestedRoute(route);
                HistoryService.push(completeRoute, this.context);
                return;
            }
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    preventDefault: () => event.preventDefault(),
                    stopPropagation: () => event.stopPropagation(),
                }));
            }
            this.onClose();
        };
        this.closePopover = () => {
            this.setState({ open: false });
        };
        this.openPopover = () => {
            const { onClick } = this.props;
            this.setState({ open: true }, trigger(onClick, new ClickEvent()));
        };
    }
    shouldClose() {
        const { onBeforeClose } = this.props;
        let close = true;
        if (isFunction(onBeforeClose)) {
            const abort = () => { close = false; };
            onBeforeClose(new AbortableCloseEvent({ abort }));
        }
        return close;
    }
    onClose() {
        const shouldClose = this.shouldClose();
        if (!shouldClose) {
            return;
        }
        const { onClose } = this.props;
        if (isFunction(onClose)) {
            onClose(new CloseEvent());
        }
    }
    renderChildren() {
        const { children, uuid } = this.props;
        const suboptions = children ? seizeAndForwardChildrenEvents(children, [['onClose', this.closePopover]]) : null;
        if (!uuid) {
            return suboptions;
        }
        return (React.createElement(Container, { acceptedTypes: OptionContainer.acceptedTypes, uuid: uuid }, suboptions));
    }
    renderPopoverTarget() {
        const { value } = this.props;
        return (React.createElement("div", { className: "c-option__popover", onClick: this.openPopover },
            React.createElement(Option_1, { value: value, visible: true }),
            React.createElement(CollapseArrow, { collapsed: false, direction: CollapseArrowDirection.RIGHT })));
    }
    renderPopoverContent() {
        return (React.createElement(Popover.Content, null,
            React.createElement(Fragment, null, this.renderChildren())));
    }
    renderOptionPopover() {
        const { open } = this.state;
        return (React.createElement(Popover, { onClose: this.closePopover, open: open, placement: Placement.RIGHT },
            this.renderPopoverTarget(),
            this.renderPopoverContent()));
    }
    getClassNames() {
        const { highlighted } = this.props;
        return classNames({
            'c-option': true,
            'c-option--highlighted': Boolean(highlighted),
        });
    }
    renderOption(routeContext) {
        const { enabled, onBlur, onContextMenuClick, onDoubleClick, onFocus, value } = this.props;
        return (React.createElement("button", { className: this.getClassNames(), disabled: !enabled, onBlur: trigger(onBlur, new FocusEvent()), onClick: event => this.onClick(event, routeContext), onContextMenu: trigger(onContextMenuClick, new ClickEvent()), onDoubleClick: trigger(onDoubleClick, new ClickEvent()), onFocus: trigger(onFocus, new FocusEvent()) }, MessageService.translate(value)));
    }
    render() {
        const { visible, hasSuboptions = Option_1.defaultProps.hasSuboptions } = this.props;
        if (!visible) {
            return null;
        }
        return (React.createElement(RouteContext.Context.Consumer, null, routeContext => (hasSuboptions ? this.renderOptionPopover() : this.renderOption(routeContext))));
    }
};
Option.contextType = DataContext.Context;
Option.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    enabled: bool,
    hasSuboptions: bool,
    highlighted: bool,
    onBlur: eventListener,
    onClick: eventListener,
    onClose: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    onFocus: eventListener,
    preventDefault: bool.group('events'),
    route: string,
    stopPropagation: bool.group('events'),
    uuid: string,
    value: expression,
    visible: bool,
};
Option.defaultProps = {
    enabled: true,
    hasSuboptions: false,
    preventDefault: false,
    stopPropagation: false,
    value: 'Option',
    visible: true,
};
Option = Option_1 = __decorate([
    AwesomeComponent({ api: OptionAPI, containers: [OptionContainer], type: ComponentType.NAVIGATION })
], Option);
export { Option, };
//# sourceMappingURL=option.js.map